export class Contact
{
    name: string;
    phone: string;
}